import React from "react";

export default function Pagination({ page, totalPages, onChange }) {
  if (totalPages <= 1) return null;

  const pages = [];
  for (let i = 1; i <= totalPages; i += 1) pages.push(i);

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t border-[#f8dde1] px-5 py-4">
      <div className="text-[13px] text-slate-500">
        Page {page} of {totalPages}
      </div>

      <div className="flex flex-wrap items-center gap-2">
        <button
          type="button"
          disabled={page === 1}
          onClick={() => onChange(page - 1)}
          className="rounded-[10px] border border-[#f2c6cc] px-3 py-2 text-[12px] font-semibold text-slate-600 disabled:cursor-not-allowed disabled:opacity-50"
        >
          Prev
        </button>

        {pages.map((p) => (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={[
              "min-w-[36px] rounded-[10px] border px-3 py-2 text-[12px] font-semibold",
              p === page
                ? "border-[#d86a78] bg-[#d86a78] text-white"
                : "border-[#f2c6cc] text-slate-600 hover:bg-[#fff8f9]",
            ].join(" ")}
          >
            {p}
          </button>
        ))}

        <button
          type="button"
          disabled={page === totalPages}
          onClick={() => onChange(page + 1)}
          className="rounded-[10px] border border-[#f2c6cc] px-3 py-2 text-[12px] font-semibold text-slate-600 disabled:cursor-not-allowed disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
}